import React from 'react';
import styled from 'styled-components';

import { useTokensLandingData } from '@/modules/TokensLanding/hooks';
import HeroBanner from '@/components/HeroBanner';

function Hero() {
  const {
    heroImage,
    heroMobileImage,
    heroTitle,
    heroSubtitle,
    heroButtonTitle,
    heroButtonLink,
  } = useTokensLandingData();

  if (!heroImage || !heroTitle) {
    return null;
  }

  return (
    <Component>
      <HeroBanner
        image={heroImage}
        imageMobile={heroMobileImage}
        title={heroTitle}
        subtitle={heroSubtitle ?? ''}
        buttonText={heroButtonTitle ?? ''}
        buttonLink={heroButtonLink ?? ''}
      />
    </Component>
  );
}

export default Hero;

const Component = styled.section`
  padding-bottom: 15px;
`;
